import React from 'react'
import PropTypes from 'prop-types'

import FundHeaderMain from './FundHeaderMain.jsx'
import FundHeaderSubNav from './FundHeaderSubNav.jsx'
import './FundHeader.css'
import { ETF_FUND } from '../../Helpers/FundTypes.js'

function FundHeader({
  fund,
  navFields,
  showEmailSubscriptionModal,
  setShowEmailSubscriptionCenterModal,
  fundSubscriptionDocs,
  mergerDate,
  isGovtMoneyMarketFund,
  productList,
}) {
  const isEtf = fund.fundGroup === ETF_FUND

  return (
    <section className="u-adel-reset" id="fund-header">
      {/* Hide this for now - u-hidden */}
      <div
        className="Grid Grid--alignMiddle js-top-ad-banne u-bgColorDuff u-paddingVert3gu u-hidden"
        data-collapsible="true"
        data-brand-message="multi-managed"
      >
        <p className="u-sizeConstrained u-textSecondary u-textSizeMsrp2">
          <span className="Icon u-sizeFit u-textSizeMsrp3 u-paddingRight2gu">
            info_outline
          </span>
          The fund is offered only through certain wrap fee programs sponsored
          and/or managed by Ameriprise Financial, Inc. or its affiliates.
        </p>
      </div>

      <FundHeaderMain
        truncate={false}
        fund={fund}
        isEtf={isEtf}
        isGovtMoneyMarketFund={isGovtMoneyMarketFund}
        showEmailSubscriptionModal={showEmailSubscriptionModal}
        setShowEmailSubscriptionCenterModal={
          setShowEmailSubscriptionCenterModal
        }
        fundSubscriptionDocs={fundSubscriptionDocs}
        mergerDate={mergerDate}
        productList={productList}
      />

      {!mergerDate && <FundHeaderSubNav navFields={navFields} />}
    </section>
  )
}

FundHeader.propTypes = {
  fund: PropTypes.object.isRequired,
  isEtf: PropTypes.bool,
  showEmailSubscriptionModal: PropTypes.bool,
  setShowEmailSubscriptionCenterModal: PropTypes.func,
  fundSubscriptionDocs: PropTypes.array,
  navFields: PropTypes.object,
}

export default FundHeader
